import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { McpAccessProfile } from '../../../Api/McpAccess';

export interface McpAccessActionCellProps {
  profile: McpAccessProfile;
  rotating: boolean;
  revoking: boolean;
  onRotate: (profile: McpAccessProfile) => void;
  onRevoke: (profile: McpAccessProfile) => void;
}

export const McpAccessActionCell = ({ profile, rotating, revoking, onRotate, onRevoke }: McpAccessActionCellProps) => {
  const disabled = rotating || revoking;
  // Each button is wrapped in a span so the tooltip still shows while the button is disabled.
  return (
    <>
      <Tooltip title="Rotate token">
        <span>
          <IconButton
            size="small"
            disabled={disabled}
            aria-label={`Rotate token for ${profile.title}`}
            data-testid={`rotate-${profile.access_id}`}
            onClick={() => onRotate(profile)}>
            {rotating ? <CircularProgress size={16} /> : <AutorenewIcon fontSize="small" />}
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Revoke">
        <span>
          <IconButton
            size="small"
            disabled={disabled}
            aria-label={`Revoke ${profile.title}`}
            data-testid={`revoke-${profile.access_id}`}
            onClick={() => onRevoke(profile)}>
            {revoking ? <CircularProgress size={16} /> : <DeleteOutlineIcon fontSize="small" />}
          </IconButton>
        </span>
      </Tooltip>
    </>
  );
};
